import React from "react";



interface StepperProps {
  steps: { number: number; label: string }[];
  currentStep: number;
  handleStepChange: (step: number) => void;
}

export default function Stepper({ steps, currentStep, handleStepChange }: StepperProps) {
  return (
    <div className="flex items-center justify-center ">
      {steps.map((step, index) => (
        <div key={step.number} className="">
          <div className="flex items-center">
            {index === 0 && (
              <div className="w-8 flex h-0.5 bg-[#c7c7c7]" />
            )}

            <div className="" onClick={() => handleStepChange(step.number)}>
              <div
                className={`w-4 h-4 flex items-center justify-center cursor-pointer rounded-full border-2 text-sm font-semibold 
              ${currentStep === step.number
                    ? "bg-[#c7c7c7] text-[#c7c7c7] border-blue-600"
                    : "bg-black text-[#c7c7c7] border-gray-300"
                  }`}
              >
                {/* {step.number} */}
              </div>
            </div>

            {index !== steps.length - 1 && (
              <div className="w-24 flex h-0.5 bg-[#c7c7c7]" />
            )}
            {index === steps.length - 1 && (
              <div className="w-8 flex h-0.5 bg-[#c7c7c7]" />
            )}

          </div>
          
          <span
            className={`mt-1 ${index === 0 ? "ml-1" : index === 1 ? "-ml-3" : index === 2 ? "-ml-7":"-ml-5"} text-xs cursor-pointer  ${currentStep === step.number
                ? "text-blue-600 font-medium"
                : "text-gray-400"
              }`}
          >
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );
}
